<template>
  <div class="project-status">
    <el-dialog
      title="添加项目流程状态"
      :visible.sync="statusDialog"
      top="29vh"
      width="600px"
      :lock-scroll="false"
      :close-on-click-modal="false"
      @close="closeDialog"
    >
      <div v-loading="isLoading">
        <el-form
          ref="ruleForm"
          class="ruleForm"
          :model="form"
          :rules="rules"
          label-position="right"
          label-width="105px"
        >
          <el-form-item label="流程状态：" prop="dockingStatus">
            <enumerate
              url="/api/project/getsimpledockingstatus"
              v-model="form.dockingStatus"
              placeholder="项目流程状态"
            />
          </el-form-item>
          <el-form-item label="子流程说明：" prop="description">
            <el-input
              v-model="form.description"
              type="textarea"
              :autosize="{ minRows: 5 }"
              placeholder=""
              maxlength="200"
              show-word-limit
              resize="none"
            >
            </el-input>
          </el-form-item>
          <el-form-item label="附件上传" prop="fileUploadList">
            <file-upload
              url="/api/Project/UploadMultiFile"
              :file-list.sync="form.fileUploadList"
              accept="text/plain,application/vnd.ms-powerpoint,application/vnd.openxmlformats-officedocument.presentationml.presentation,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
              :num-limit="5"
            />
          </el-form-item>
        </el-form>
        <p class="submit fn-text-center">
          <el-button type="primary" @click="handleCreate('ruleForm')"
            >确定</el-button
          >
        </p>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    projectId: {
      type: String,
      required: true
    },
    dataType: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      statusDialog: true,
      form: {
        dockingStatus: "",
        description: "",
        fileUploadList: [] // attList 相对应
      },
      rules: {
        dockingStatus: [
          {
            required: true,
            message: "流程状态不能为空",
            trigger: ["blur", "change"]
          }
        ]
      },
      isLoading: false
    };
  },
  methods: {
    // 关闭弹框后回调
    closeDialog() {
      // 传递关闭上一级
      this.$emit("close", true);
    },
    // 正向处理数据 将数据处理后提交
    processDataSubmit() {
      const { fileUploadList, ...others } = this.form;
      // 处理上传文件
      const deconstruct = (file = {}) => {
        return file.response ? file.response.dataList[0] : file;
      };
      const turnFile = {
        attList: fileUploadList
      };
      Object.keys(turnFile).map((key) => {
        turnFile[key] = turnFile[key].map((item) => {
          return deconstruct(item);
        });
      });
      return {
        ...others,
        ...turnFile
      };
    },
    handleCreate(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loadCreate();
        }
      });
    },
    loadCreate() {
      this.isLoading = true;
      this.$api(
        "project",
        this.dataType === "ach" ? "addAchStatus" : "addDemStatus",
        {
          projectId: this.projectId,
          ...this.processDataSubmit()
        }
      ).then((res) => {
        this.isLoading = false;
        this.$message({
          message: res.message,
          type: res.code === 0 ? "success" : "error"
        });
        if (res.code === 0) {
          this.$emit("complete", true);
        }
      });
    }
  }
};
</script>

<style lang="less" scoped></style>
